import { Role } from './roles'

export const QcViewRoles = [
  Role.ADMIN,
  Role.QC_SUPERVISOR,
  Role.QC_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PRODUCTION_OFFICER,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.SALES_OFFICER,
  Role.ACCOUNTING_SUPERVISOR,
  Role.ACCOUNTING_OFFICER,
  Role.QSS_OFFICER,
]

export const QcModifyRoles = [Role.ADMIN, Role.QC_SUPERVISOR, Role.QC_OFFICER]

export const Qc8030ModifyRoles = [
  Role.ADMIN,
  Role.ADMIN_CKD,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PRODUCTION_OFFICER,
]
